import Swiper from '../lib/swiper';
import { gsap } from 'gsap';

class KeyfiguresTabs {
  constructor(config = {}) {
    const {
      tabs
    } = config;

    this.element =  document.querySelector(tabs);
    if(!this.element) return;

    if(this.element) {
      this.tabButtons = this.element.querySelectorAll('.ns-keyfigures-tabs__tab-button');
      this.tabContent = this.element.querySelector('.ns-keyfigures-tabs__tab-content');
      this.tabPanes = this.tabContent.querySelectorAll('.ns-keyfigures-tabs__tab-pane');
      this.swipers = [];
      this.numberElements = [];
      this.videos = [];

      this.tabPanes.forEach(pane => {
        const video = pane.querySelector('.ns-keyfigures-tabs__video');
        if (video) {
          this.videos.push(video);
          gsap.set(video, {
            opacity: 1,
            x: '120%'
          });
        }
      });

      this.initAllSwipers();
      this.init();
    }
  }

  initAllSwipers() {
    this.tabPanes.forEach((pane, index) => {
      const swiperContainer = pane.querySelector('.swiper-container');
      if (swiperContainer) {
        const nextButton = swiperContainer.querySelector('.swiper-button--next');
        const prevButton = swiperContainer.querySelector('.swiper-button--prev');
        const pagination = swiperContainer.querySelector('.swiper-pagination');

        if (nextButton) nextButton.classList.add(`swiper-button--next-${index}`);
        if (prevButton) prevButton.classList.add(`swiper-button--prev-${index}`);
        if (pagination) pagination.classList.add(`swiper-pagination-${index}`);

        this.swipers[index] = new Swiper(swiperContainer, {
          init: false,
          loop: true,
          autoplay: false,
          pauseOnMouseEnter: true,
          slidesPerView: 1,
          spaceBetween: 30,
          duration: 6000,
          speed: 500,
          navigation: {
            nextEl: `.swiper-button--next-${index}`,
            prevEl: `.swiper-button--prev-${index}`,
          },
          pagination: {
            el: `.swiper-pagination-${index}`,
            type: 'bullets',
            clickable: true
          },
          on: {
            init: () => {
              const activeSlide = this.swipers[index].slides[this.swipers[index].activeIndex];
              this.animateNumbers(activeSlide);
            },
            slideChange: () => {
              const activeSlide = this.swipers[index].slides[this.swipers[index].activeIndex];
              this.animateNumbers(activeSlide);
            }
          }
        });
      }
    });
  }

  animateNumbers(slide) {
    const numbers = slide.querySelectorAll('.ns-keyfigure__number');

    numbers.forEach(number => {
      gsap.set(number, {
        opacity: 1
      });

      const value = number.textContent;
      number.textContent = '';

      const container = document.createElement('div');
      container.style.display = 'inline-block';
      number.appendChild(container);

      [...value].forEach((digit, index) => {
        const span = document.createElement('span');
        span.textContent = digit;
        span.style.display = 'inline-block';
        container.appendChild(span);

        gsap.fromTo(span,
          {
            opacity: 0,
            y: 20
          },
          {
            opacity: 1,
            y: 0,
            duration: .6,
            delay: 0.2 * index,
            ease: "power2.out"
          }
        );
      });
    });
  }

  init() {
    if (this.tabButtons.length > 0) {
      this.setActiveTab(0);
    }

    this.tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.setActiveTab(index));
    });
  }

  setActiveTab(index) {
    this.tabButtons.forEach(button => {
      button.classList.remove('active');
    });
    this.tabPanes.forEach(pane => {
      pane.classList.remove('active');
    });

    this.tabButtons[index].classList.add('active');
    this.tabPanes[index].classList.add('active');

    this.videos.forEach((video, videoIndex) => {
      if (videoIndex === index) {
        gsap.fromTo(video,
          {
            opacity: 1,
            x: '120%'
          },
          {
            opacity: 1,
            x: '0%',
            duration: 0.8,
            ease: "power2.out"
          }
        );
      } else {
        gsap.set(video, {
          opacity: 1,
          x: '120%'
        });
      }
    });

    if (this.swipers[index]) {
      if (!this.swipers[index].initialized) {
        this.swipers[index].init();
      } else {
        const activeSlide = this.swipers[index].slides[this.swipers[index].activeIndex];
        this.animateNumbers(activeSlide);
      }
      this.swipers[index].update();
    }
  }
}
export default KeyfiguresTabs;
